import React, { useEffect, useState } from "react";
import { AlertTriangle, Download } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const SuspectEventsPanel = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/events/suspect").then((r) => setS(r.data)).catch(() => setS({ suspect: 0, public: 0, sparse_dates: 0 })); }, []);

  const exportCsv = async () => {
    try {
      const r = await api.get("/admin/events/suspect/export", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: `oddlytrue-suspect-events-${new Date().toISOString().slice(0, 10)}.csv` });
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success(`Exported ${s?.suspect ?? ""} suspect events`);
    } catch { toast.error("Export failed"); }
  };

  return (
    <section className="mb-10 rounded-2xl border border-gold/60 bg-paper p-5" data-testid="suspect-events-panel">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <h2 className="text-base md:text-lg font-bold text-ink flex items-center gap-2"><AlertTriangle className="w-4 h-4 text-gold" /> Suspect events (quarantined)</h2>
          <p className="mt-1 font-mono text-xs text-ink-muted">
            <span data-testid="suspect-count" className="text-ink font-semibold">{s?.suspect ?? "…"}</span> filler rows hidden from the site & emails ·{" "}
            <span data-testid="public-count" className="text-ink font-semibold">{s?.public ?? "…"}</span> public events ·{" "}
            <span data-testid="sparse-count" className="text-ink font-semibold">{s?.sparse_dates ?? "…"}</span> dates with fewer than 3 events
          </p>
        </div>
        <button data-testid="suspect-export" onClick={exportCsv} className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-ink text-white font-mono text-sm hover:bg-gold hover:text-ink transition-colors">
          <Download className="w-4 h-4" /> Export suspect CSV
        </button>
      </div>
    </section>
  );
};
